import Heading from "./Heading";
import Section from "./Section";

import { roadmap } from "../constants";
import LottieAnimation from "./LottieAnimation";

const Roadmap = () => (
  <Section crosses className="max-w-full overflow-hidden" id="services">
    <div className="container md:pb-10">
      <Heading title="Our Services" />

      <div className="relative mx-auto grid max-w-screen-lg gap-6 lg:grid-cols-2 lg:gap-x-12 2xl:gap-x-16">
        {roadmap.map(({ id, imageUrl, speed, title, text }) => (
          <div
            key={id}
            className="mx-auto max-w-[40rem] rounded-[2.5rem] bg-conic-gradient p-0.5 md:flex"
          >
            <div className="relative mx-auto overflow-hidden rounded-[2.4375rem] bg-black p-5 xl:p-8">
              <LottieAnimation source={imageUrl} speed={speed} />

              <p className="mb-4 mt-8 text-[20px] font-semibold sm:text-[26px] md:text-[28px] lg:text-[24px] xl:text-[26px] leading-normal">
                {title}
              </p>
              <p className="body-2 text-n-2">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </Section>
);

export default Roadmap;
